import { matchPath } from "react-router-dom";

export const getUrlVars = () => {
  var vars = {};
  window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,
  function(m,key,value) {
    vars[key] = value;
  });
  return vars;
}

export const redirectOutside = (url) => {
  if(url){
    window.open(url, '_system');
  }
}

export const verificarPadraoUrl = (url, pattern) => {
    return matchPath(url, { path: pattern, exact: true });
};